export const normalizePaymentIdentifier = (value) => `${value || ''}`.trim().toUpperCase()

export const isMidtransGateway = (gateway) =>
    normalizePaymentIdentifier(gateway?.identifier || gateway?.ms_payment_identifier) === 'MIDTRANS'

export const isXenditGateway = (gateway) =>
    normalizePaymentIdentifier(gateway?.identifier || gateway?.ms_payment_identifier) === 'XENDIT'

export const paymentGatewayRedirectUrl = (gateway) => {
    if (!gateway || typeof gateway !== 'object') return null
    const direct = `${gateway.redirect_url || ''}`.trim()
    if (direct) return direct
    const action = Array.isArray(gateway.actions)
        ? gateway.actions.find((item) => item?.type === 'REDIRECT_CUSTOMER' || item?.descriptor === 'WEB_URL')
        : null
    return `${action?.value || ''}`.trim() || null
}

export const paymentGatewayPresentValue = (gateway, descriptor) => {
    const action = Array.isArray(gateway?.actions)
        ? gateway.actions.find((item) => item?.type === 'PRESENT_TO_CUSTOMER' && item?.descriptor === descriptor)
        : null
    return `${action?.value || ''}`.trim() || null
}

export const paymentGatewayExpiresAt = (gateway) => {
    const value = `${gateway?.expires_at || ''}`.trim()
    const timestamp = Date.parse(value)
    return Number.isFinite(timestamp) ? new Date(timestamp).toISOString() : null
}

export const normalizePaymentGatewayStatus = (value) => `${value || ''}`
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_')

export const isPaymentGatewaySucceeded = (gateway) =>
    normalizePaymentGatewayStatus(gateway?.status) === 'SUCCEEDED'

export const isPaymentGatewayExpired = (gateway) =>
    ['EXPIRED', 'FAILED', 'CANCELED', 'CANCELLED'].includes(normalizePaymentGatewayStatus(gateway?.status))

export const isSafePaymentRedirectUrl = (value) => {
    try {
        return new URL(value).protocol === 'https:'
    } catch (error) {
        return false
    }
}
